<div class="flex justify-content-between mb-4">
    <app-select-button-input
        id="type"
        [form]="form"
        [options]="suggestionTypes()"
        prefix="">
    </app-select-button-input>

    <div class="flex align-items-center justify-content-end gap">
        <app-button
            label="workData.suggestion.enum.type.satisfaction"
            icon="pi-plus"
            (clickEvent)="create(WorkDataSuggestionTypeEnum.satisfaction)"
        ></app-button>
        <app-button
            label="workData.suggestion.enum.type.complaint"
            icon="pi-plus"
            (clickEvent)="create(WorkDataSuggestionTypeEnum.complaint)"
        ></app-button>
        <app-button
            label="workData.suggestion.enum.type.finding"
            icon="pi-plus"
            (clickEvent)="create(WorkDataSuggestionTypeEnum.finding)"
        ></app-button>
    </div>
</div>

<app-work-suggestions-list [inFolder]="true" [additionalFilter]="additionalFilter()"></app-work-suggestions-list>
